import React from 'react';
import './DigimonCard.css';
const DigimonCard = (props) =>{
    return (
    <a href={"https://digimon.fandom.com/wiki/" + props.digimon.name}>
    <div className='digimonCard'>
        <h1>Name: {props.digimon.name}</h1>
        <h2>Level: {props.digimon.level}</h2>
        <img src={props.digimon.img} alt="" />
    </div>
    </a>
    )
}
export default DigimonCard;